/* eslint-disable import/prefer-default-export */
/* eslint-disable react/require-default-props */
/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Root = styled.div`
   padding: 28px 12px;
   text-align: center;
   display: grid;
   gap: 10px;
   place-items: center;
`;

// Quadrado pastel com o ícone — slot opcional (spec do handoff de design de
// transferências, 2026-09-10). Sem `icon`, nada muda para o legado.
const IconBox = styled.span`
   display: inline-flex;
   align-items: center;
   justify-content: center;
   width: 48px;
   height: 48px;
   border-radius: 13px;
   background: ${({ theme }) => theme?.colors?.primarySoft ?? 'rgba(24,95,165,0.12)'};
   color: ${({ theme }) => theme?.colors?.primary ?? '#185FA5'};
   font-size: 22px;
`;

const Title = styled.h3`
   margin: 0;
   font-size: 16px;
   color: ${({ theme }) => theme?.colors?.textPrimary ?? '#111'};
`;

const Desc = styled.p`
   margin: 0;
   font-size: 14px;
   color: ${({ theme }) => theme?.colors?.textMuted ?? '#666'};
   max-width: 520px;
`;

const Actions = styled.div`
   display: flex;
   gap: 8px;
   flex-wrap: wrap;
   justify-content: center;
`;

export function EmptyState({ title, description, action, icon }) {
   return (
      <Root role="status" aria-live="polite">
         {icon ? <IconBox aria-hidden="true">{icon}</IconBox> : null}
         <Title>{title}</Title>
         {description ? <Desc>{description}</Desc> : null}
         {action ? <Actions>{action}</Actions> : null}
      </Root>
   );
}

EmptyState.propTypes = {
   title: PropTypes.node,
   description: PropTypes.node,
   action: PropTypes.node,
   icon: PropTypes.node,
};
